/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  GET_BANNER_REQUEST,
  GET_BANNER_SUCCESS,
  GET_BANNER_FAILURE,
  CREATE_BANNER_REQUEST,
  CREATE_BANNER_SUCCESS,
  CREATE_BANNER_FAILURE,
} from "./bannerLogoTypes";

import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;
// let baseUrl = `http://13.71.2.248:1338/api/v2/users_management`;

const getBannerRequest = () => {
  return {
    type: GET_BANNER_REQUEST,
  };
};

const getBannerSuccess = (payload) => {
  return {
    type: GET_BANNER_SUCCESS,
    payload: payload,
  };
};

const getBannerFaliure = (error) => {
  return {
    type: GET_BANNER_FAILURE,
    payload: error,
  };
};

const getBanner = (clientId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getBannerRequest());
    let url = `${baseUrl}/banner_and_logo/get?clientId=${clientId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getBannerSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getBannerFaliure(err.response));
      });
  };
};

const createBannerRequest = () => {
  return {
    type: CREATE_BANNER_REQUEST,
  };
};

const createBannerSuccess = (payload) => {
  return {
    type: CREATE_BANNER_SUCCESS,
    payload: payload,
  };
};

const createBannerFaliure = (error) => {
  return {
    type: CREATE_BANNER_FAILURE,
    payload: error,
  };
};

const createBanner = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  let data = new FormData();

  data.append("file", payload);
  data.append("clientId", "a544828e-4955-417f-a9a5-fe6e43a68cd6");

  return (dispatch) => {
    dispatch(createBannerRequest());
    let url = `${baseUrl}/banner_and_logo/upload`;
    return axios
      .post(url, data, headers)
      .then((response) => {
        dispatch(createBannerSuccess(response.data));
        return response.data;
      })
      .catch((err) => {
        dispatch(createBannerFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export { getBanner, createBanner };
